import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductTariffs', request)
}

async function put(request) {
    return await putMethod('/api/ownProductTariffs', request)
}

async function post(body) {
    return await postMethod('/api/ownProductTariffs', body)
}

export {get, put, post}
